export default __webpack_public_path__ + "static/media/gold.b3e9396b.jpg";